module.exports = __webpack_public_path__ + "img/logo.b7f96dec.webp";